// This route doens't exist.
// Just to redirect to home.
// ================ ROUTES  =================
// ================ REDIRECT =================
// Just to
export const R_GO_TO_HOME = "/ir-para-home";
// ================ ROUTES  =================
export const R_MANUT = "/manut-page";
export const R_ROOT = "/";
export const R_SIGNUP = "/cadastro/";
export const R_LOGIN_LIMBO = "/cadastro/confirmacao";
export const R_LOGIN = "/login";
export const R_LOGIN_CODE = "/login?:code";
export const R_LOGIN_BY_USER = "/cadastro/:any";
export const R_LOGIN_BY_USER_AND_PAGE = "/login/:any/:any";
export const R_BUY = "/comprar";
export const R_MY_ACCOUNT = "/minha-conta";
export const R_MY_ACCOUNT_SETTINGS = "/configuracoes-de-conta";
export const R_BUY_PROBRAIN = "/comprar-probrain";
export const R_REGISTER_SUCCESS = "/cadastro/*/obrigado";

export const R_GAME_RANKING = "/ranking-jogos";
export const R_DASHBOARD = "/painel";
export const R_DASHBOARD_A = "/painel-a";
export const R_DASHBOARD_B = "/painel-b";
export const R_MODULAR_DASHBOARD = "/painel-modular";
export const R_TAKE_TEST = "/fazer-teste";
export const R_TAKE_TEST_PLAN = "/fazer-teste/plano";
export const R_COINSTORE = "/colecao";
export const R_LOADING = "/Loading";
export const R_LIST_MY_USERS = "/meus-usuarios";
export const R_SUPPORT = "/ajuda";
export const R_CONTENTS = "/conteudos";
export const R_CONTENTS_INFO = "/conteudos/:any/:any";
export const GET_R_CONTS_INFO = (type, id) => `/conteudos/${type}/${id}`;
export const R_GAME_SCREEN = "/tela-de-jogo";
export const R_ACTIVTS = "/jogos";
export const R_ACTIVTS_MY_ACTIVITIES = "/jogos/minhas-atividades";
export const R_ACTIVTS_ALL = "/jogos/todos";
export const R_ACTIVTS_ALL_AUDIOS = "/jogos/todos-audios";
export const R_ACTIVTS_ALL_GAMES = "/jogos/todos-jogos";
export const R_ACTIVTS_TAB = "/jogos/:any";
// export const R_ACTIVTS_INFO = "/jogos/info/:any";
export const R_ACTIVTS_INFO = "/jogo/:any";
export const R_ACHIEVEMENTS = "/conquistas";
export const R_ACHIEVEMENTS_GOALS = "/conquistas/metas";
export const R_ACTIVTS_CATEGORY = "jogos/:any";

//export const R_ACHIEVEMENTS_V2 = "/conquistas_v2";
// export const GET_R_ACTIVTS_INFO = (type) => `/jogos/info/${type}`;
export const GET_R_ACTIVTS_INFO = (type, language = "pt_br") => `/jogo/${type}?language=${language}`;
export const R_ADD_TASK = "/add-tarefa/:any";
export const R_ADD_TASK_TO_USERS = "/add-tarefa-usuarios/:any";
export const GET_R_ADD_TASK_TO_USERS = (id_game) =>
  `/add-tarefa-usuarios/${id_game}`;
// V2
export const GET_R_ADD_TASK = (id) => `/add-tarefa/${id}`;
export const R_PROGRESS = "/progresso";
export const R_PROGRESS_BY_GAME = "/progresso/por-jogo";
export const R_PROGRESS_GENERAL = "/progresso/geral";
export const R_STATIS = "/progresso/:any";
export const R_STATIS_LEVEL = "/progresso/:any/:any";
export const GET_R_STATIS = (id, level = null) =>
  `/progresso/${id}${level ? "/" + level : ""}`;
export const GET_R_STATIS_LEVEL = (id, level) => `/progresso/${id}/${level}`;
export const R_SELECT_USER = "/selecionar-usuario";
export const R_INVITE_USER = "/convidar-usuario";
export const R_RESCUE_CODE = "/resgatar-codigo";
export const R_BOT_AFINANDO = "/pixie";
export const R_MANAGE_PLAN = "/gerenciar-plano";
export const R_MANAGE_PURCHASES = "/gerenciar-compra";
export const R_LEGAL_INFO = "/informacoes-legais/:any";
export const GET_LEGAL_INFO = (url) => `/informacoes-legais/${url}`;
